import { IInsuranceCompany } from "../../../core/modules/admin-modules/insurance-company/models/insurance-company.model";

export class PatchPayerList {
  static readonly type = '[Payer] Patch Payer List';
  constructor(public payload: IInsuranceCompany[]) {}
}